<template>
  <div class="bot-nav" v-if="!this.hideBottombar">
    <v-bottom-nav  fixed value="show" :active="activeTab">
      <v-btn flat value="organize" @click="onActiveTabChange('organize')" >
        <v-icon medium class="organize-icon" :class="menuActive('organize')">outlined_flag</v-icon>
      </v-btn>
      <v-btn flat value="tasks" @click="onActiveTabChange('tasks')">
        <i class="tasks-icon" :class="menuActive('tasks')"></i>
      </v-btn>
      <v-btn flat value="messages" @click="onActiveTabChange('messages')">
        <i class ='message-icon' :class="menuActive('messages')"></i>
      </v-btn>
      <v-btn flat value="profile" @click="onActiveTabChange('profile')">
        <i class='profile-icon' :class="menuActive('profile')" ></i>
      </v-btn>
    </v-bottom-nav>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation';

export default {
  mixins: [navigation],
  props: ['activeTab', 'hideBottombar'],
  data() {
    return {
    };
  },
  methods: {
    menuActive(item) {
      const active = this.activeTab === item;
      return { active };
    },
    onActiveTabChange(value) {
      this.navigate(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
.bot-nav {
  display: none;
}

@media only screen and (max-width:600px) {
  .bot-nav {
    display: inherit;
  }
}

.bot-nav .bottom-nav .btn .btn--active .btn__content:before {
  border: none;
  opacity: 1;
}

.bottom-nav .btn  {
  border:none;
  min-width: 40px;
}

.organize-icon {
  color: #939596 !important;
}

.organize-icon.active {
  color: #ffc175 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Bottombar.vue